import type React from "react";
import {Stack, Typography} from "@mui/material";
import type {SxProps, Theme} from "@mui/material/styles";
import {GreyPaper} from "~/components/GreyPaper/GreyPaper";
import {MONO_FONT} from "~/style/fonts";

export type SummaryRow = {
    title: string;
    value: string;
    /** Set when the value itself is the warning, such as a zero balance. */
    valueColor?: 'error';
};

/** Title and value rows on the grey summary paper. */
export const SummaryRows: React.FC<{rows: SummaryRow[], sx?: SxProps<Theme>}> = ({rows, sx}) => {
    return (
        <GreyPaper sx={sx}>
            <Stack gap={0.75}>
                {rows.map(row => (
                    <Stack key={row.title} direction="row" justifyContent="space-between">
                        <Typography variant="caption" color="text.secondary">{row.title}</Typography>
                        <Typography variant="caption" fontWeight={600} fontFamily={MONO_FONT} color={row.valueColor}>
                            {row.value}
                        </Typography>
                    </Stack>
                ))}
            </Stack>
        </GreyPaper>
    );
};
